// Global Enums
import {
  webPages,
} from 'common.enums';

// Global Components
import * as React from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom';

// Helpers
import config from '../config';

// Pages
import ChampionshipPage from '../components/pages/ChampionshipPage';
import ChampionshipsPage from '../components/pages/ChampionshipsPage';
import CustomPage from '../components/pages/CustomPage';
import RegattasPage from '../components/pages/RegattasPage';
import NotFoundPage from '../components/pages/NotFoundPage';
import ProfilePage from '../components/pages/ProfilePage';
import RegattaPage from '../components/pages/RegattaPage';
import RegionsPage from '../components/pages/RegionsPage';

const Router = function () {
  return (
    <Routes>
      <Route
        element={<ChampionshipPage />}
        key={webPages.championshipPage}
        path={'/championship/:param1/:param2?'}
      />
      <Route
        element={<RegattaPage />}
        key={webPages.regattaPage}
        path={'/regatta/:param1/:param2?'}
      />
      <Route
        element={<CustomPage />}
        key={webPages.customPage}
        path={'/page/:param1'}
      />
      <Route
        element={<RegionsPage />}
        key={webPages.regionsPage}
        path={'/regions'}
      />
      <Route
        element={<ProfilePage />}
        key={webPages.profilePage}
        path={'/profile'}
      />
      <Route
        action={() => {
          if (window) {
            window.location.assign(config.ADMIN_URL);
          }

          return null;
        }}
        key={'admin'}
        path={'/admin'}
      />
      <Route
        element={<ChampionshipsPage />}
        key={webPages.championshipsPage}
        path={'/championships/:param1?'}
      />
      <Route
        element={<RegattasPage />}
        key={webPages.regattasPage}
        path={'/:param1?'}
      />
      <Route
        element={<NotFoundPage />}
        key={'not-found-page'}
        path={'*'}
      />
    </Routes>
  );
};

export default Router;
